import type { MouseEvent } from 'react'
import type { IButtonProps } from 'atoms/Button'

import { ButtonCorners } from 'atoms/Button'
import {
  ControlForwardSecondaryOpacityDark,
  ControlForwardSecondaryOpacityDarkVerticalFluid,
  InlineForwardButton,
} from 'atoms/Button/Templates'
import { RowControlsType } from '../RowContainer.h'

type ControlProps = {
  controlsType: RowControlsType
  onClick: (event: MouseEvent) => void
  disabled?: boolean
} & Pick<IButtonProps, 'corners'>

export const NextControl = ({
  controlsType,
  onClick,
  disabled,
  corners = ButtonCorners.CORNERS_LEFT_25,
}: ControlProps) => {
  const controlComponents = {
    [RowControlsType.inHeader]: InlineForwardButton,
    [RowControlsType.inRowFluid]:
      ControlForwardSecondaryOpacityDarkVerticalFluid,
    [RowControlsType.inRow]: ControlForwardSecondaryOpacityDark,
  }
  const Control =
    controlComponents[controlsType] ??
    ControlForwardSecondaryOpacityDarkVerticalFluid

  return <Control onClick={onClick} disabled={disabled} corners={corners} />
}
